import { SVButton, SVEmailInput } from '@/components/core';
import LogoImage from '@/components/LogoImage';
import { MESSAGES } from '@/constants/messages';
import { ROUTES } from '@/constants/routes';
import { useResetPassword } from '@/hooks/requests/useAuth';
import showToast from '@/utils/toast';
import { Card, Grid, Stack, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { SVForm } from '@/components/core';
import { logAnalyticsEvent } from '@/utils/analytics';
import { FORM_FIELDS } from '@/constants/formFields';
import { useAuthUser } from '@/hooks/stores/useAuthUser';

type ForgotPasswordFormValues = {
  email: string;
};

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { startResetPassword, isLoadingStartResetPassword } =
    useResetPassword();
  const formMethods = useForm<ForgotPasswordFormValues>({
    defaultValues: {
      email: '',
    },
    mode: 'onBlur',
  });
  const { isStaff } = useAuthUser();

  async function handleSubmit(data: ForgotPasswordFormValues) {
    try {
      const response = await startResetPassword({
        ...data,
        userGroup: isStaff ? 'staff' : 'teammate',
      });
      if (response !== 200) {
        showToast({ type: 'error', data: { content: MESSAGES.genericError } });
        logAnalyticsEvent({
          category: 'error',
          action: 'forgotPasswordError',
        });
        return;
      }

      navigate(ROUTES.FORGOT_PASSWORD_OTP, {
        state: data,
      });
    } catch {
      logAnalyticsEvent({
        category: 'error',
        action: 'forgotPasswordError',
      });
      showToast({ type: 'error', data: { content: MESSAGES.genericError } });
    }
  }

  return (
    <>
      <LogoImage />
      <Card>
        <SVForm<ForgotPasswordFormValues>
          methods={formMethods}
          onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <Typography variant="h6">Let's Recover Your Password</Typography>

            <SVEmailInput name="email" {...FORM_FIELDS.EMAIL} />
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <SVButton
                  isLoading={isLoadingStartResetPassword}
                  fullWidth
                  type="submit"
                  variant="primary">
                  Next
                </SVButton>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <SVButton
                  onClick={() => navigate(ROUTES.LOGIN)}
                  fullWidth
                  variant="outlined">
                  Cancel
                </SVButton>
              </Grid>
            </Grid>
          </Stack>
        </SVForm>
      </Card>
    </>
  );
}
